if (window.location.pathname.includes('search')) {
  const options = (query) => {
    return {
      order: [],
      columnDefs: [
        {
          render: function (data, type, row) {
            return `<a href="/placement/edit/${row.id}?sq=${query}">${data}</a>`;
          },
          targets: [0, 2, 3, 4],
        }, {
          render: function (data, type, row) {
            let matching_fields = data.split('|||');

            if (row.relevance_scores) {
              let scores = JSON.parse(row.relevance_scores);
              let results = Object.keys(scores)
                .filter(score => scores[score] > 0)
                .map(score => {
                  let words = score.split('_');

                  for (let i = 0; i < words.length; i++) {
                    let word = words[i];
                    words[i] = word.charAt(0).toUpperCase() + word.slice(1);
                  }

                  return words.join(' ');
                });

                matching_fields = matching_fields.concat(results);
            }

            matching_fields = matching_fields.filter(x => x != '');

            return [...new Set(matching_fields)].join(', ');
          },
          targets: [8]
        }
      ]
    }
  };

  $.each($('.data-table'), function() {
    const postData = $(this).data('post_data')
    $(this).data('options', options(postData.query));
  });

  $(window).on('tableLoaded', function (event, table) {
    let id = $(table).attr('id') || null;

    if (id && window.app_data.search_query_table) {
      setTimeout(function () {
        window.doMarking(window.app_data.search_query_table, id)
      }, 1000);
    }
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/search.js